import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  bottomLink: {
    margin: spacing(2, 0, 4),
    textAlign: 'center'
  },
  title2: {
    margin: 'auto'
  }
}))
